import { render, staticRenderFns } from "./flypay_M4.vue?vue&type=template&id=ade6f2b0&scoped=true&"
import script from "./flypay_M4.vue?vue&type=script&lang=js&"
export * from "./flypay_M4.vue?vue&type=script&lang=js&"
import style0 from "./flypay_M4.vue?vue&type=style&index=0&id=ade6f2b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ade6f2b0",
  null
  
)

export default component.exports